import { Flex } from '../UI/Flex/Flex';
import * as style from './ChatMessage.module.less';

import { ChatMessageData } from '@assets/model/RagAPI';
import { useStore } from '@assets/model/Store';
import classNames from 'classnames';
import DOMPurify from 'dompurify';
import { marked } from 'marked';
import { observer } from 'mobx-react';
import { useRef, useState } from 'react';
import { LogoBird } from '../Header/Logo';

interface ChatMessageProps {
    msgId: string;
    msg: ChatMessageData;
    response?: boolean;
}

export const ChatMessage = observer((p: ChatMessageProps) => {
    const contentRef = useRef<HTMLDivElement>(null);
    const [activeContent, setActiveContent] = useState(null);
    const msg: ChatMessageData = p.msg;
    const firmURL = useStore().firmInfo.logoURL;
    const clssses = classNames(style.chatmessage, 'fade-in');
    const msgId = p.msgId;
    const companyId = useStore().selectedReportId;

    const buildTooltipId = (citationDisplayId: string) => {
        return `tooltip_${companyId}_${citationDisplayId}`;
    };

    if (msg.isMe) {
        return (
            <>
                <Flex className={clssses} direction="column">
                    <div
                        style={{
                            height: '50px',
                            alignSelf: 'end',
                            marginBottom: '10px'
                        }}
                    >
                        <img
                            height={50}
                            width={200}
                            src={firmURL}
                            style={{
                                objectFit: 'contain',
                                objectPosition: 'right',
                                height: '100%'
                                //filter: 'invert(1)'
                            }}
                        />
                    </div>

                    <div
                        style={{
                            textAlign: 'right',
                            marginRight: '10px',
                            alignSelf: 'end'
                        }}
                    >
                        {msg.message}
                    </div>
                </Flex>
                {/* {files_references} */}
            </>
        );
    }

    const convertMarkdown = (markdown: string): string => {
        if (!markdown) {
            return 'ERROR: No message content';
        }

        const cls = style.citation_class;
        const rawHtmlWithDefault = marked.parse(markdown as string) as string;

        var matchCounter = 0;
        const finalOutput = rawHtmlWithDefault.replace(
            /(\[.*?\])/g,
            (match, p1) => {
                const p2 = p1.replace(/[\[\]]/g, '');
                matchCounter++;
                const tooltipId = buildTooltipId(p2);
                return `<a class='${cls}' data-tooltip-id="${tooltipId}">${matchCounter}</a>`;
            }
        );

        return DOMPurify.sanitize(finalOutput as string);
    };

    const formatterHTML = convertMarkdown(msg.message);

    return (
        <>
            <Flex className={clssses} direction="row">
                <div className="p-3" style={{ height: '50px' }}>
                    <LogoBird />
                </div>
                <div
                    ref={contentRef}
                    className="flex-grow-1 p-4 align-self-center"
                    style={{ marginLeft: '0px' }}
                >
                    <div dangerouslySetInnerHTML={{ __html: formatterHTML }} />
                </div>
            </Flex>
            {/* {files_references} */}
        </>
    );
});
